<div class="main-header" fxLayout="row">
  Connect Integration - Advocado Tracking Tag
</div>

<div *ngIf="traaqrTag" class="bounding-box">
  <div mat-dialog-content class="traaqr-card">
    <div fxLayout="row" *ngIf="!detected" fxLayoutAlign="center">
      <div mat-card-widget class="mat-red-50 status-card" fxFlex="100%" fxLayoutGap="2%">
        <button fxFlex="noshrink" mat-mini-fab class="shadow-none mat-red color-white center-btn">
          <mat-icon>priority_high</mat-icon>
        </button>
        <div fxFlex="grow">
          Your Tracking Tag embed code is not installed on your website. Follow the instructions below to install your
          code.
        </div>
      </div>
    </div>

    <div fxLayout="row" *ngIf="detected" fxLayoutAlign="center">
      <div mat-dialog-content class="mat-green-50 status-card" fxFlex="100%" fxLayoutGap="2%">
        <button fxFlex="noshrink" mat-mini-fab class="shadow-none mat-green color-white center-btn">
          <mat-icon>done_outline</mat-icon>
        </button>
        <div fxFlex="grow">
          Your Tracking Tag embed code is successfully installed on your website
        </div>
      </div>
    </div>

    <div class="">
      <div mat-dialog-title fxFlexAlign="center">Use Google Tag Manager</div>
      <div mat-dialog-content class="buffer-padding-x">
        Click the 'Install with Google Tag Manager' button below to begin, then select the account you would like to use.
        From there, confirm permissions and select your GTM Account and Tag Container from the dropdown menus to publish.
      </div>

      <div *ngIf="errorMessage" class="no-accounts-text">
        {{errorMessage}}
      </div>

      <div (click)="onClick($event)" *ngIf="!accountsLoading" class="google-btn">
        <div class="google-icon-wrapper">
          <img class="google-icon-svg" src="../../assets/image/google-signin-btn.svg"  alt="G"/>
        </div>
        <p class="btn-text" style="margin: 11px 0px 0px 0px;"><b>Install with Google Tag Manager</b></p>
      </div>


      <div *ngIf="!accountsLoading && accountOptions.length" class="half-width mt-1">
        <mat-form-field class="full-width">
          <mat-label>Account</mat-label>
          <mat-select [(ngModel)]="selectedAccount" (selectionChange)="selectedAccountChange()">
            <mat-optgroup *ngFor="let group of accountOptions" [label]="group.account.name">
              <mat-option [value]="group.account">
                {{group.account.name}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!containersLoading && containerOptions.length" class="half-width mt-1">
        <mat-form-field class="full-width">
          <mat-label>Container</mat-label>
          <mat-select [(ngModel)]="selectedContainer" (selectionChange)="selectedContainerChange()">
            <mat-optgroup *ngFor="let group of containerOptions" [label]="group.container.name">
              <mat-option [value]="group.container">
                {{group.container.name}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!workspacesLoading && workspaceOptions.length" class="half-width mt-1">
        <mat-form-field class="full-width">
          <mat-label>Workspace</mat-label>
          <mat-select [(ngModel)]="selectedWorkspace" (selectionChange)="selectedWorkspaceChange()">
            <mat-optgroup *ngFor="let group of workspaceOptions" [label]="group.workspace.name">
              <mat-option [value]="group.workspace">
                {{group.workspace.name}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="">
      <div fxLayout="row" fxLayoutAlign="center center">
        <div mat-dialog-title>OR</div>
      </div>
    </div>

    <div class="">
      <div class="" fxLayout="row" fxLayoutAlign="start center">
        <div>
          <div mat-dialog-title fxFlexAlign="center">Use Manual Embed</div>
        </div>
      </div>
      <div class="" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxFlex="grow" fxFlexAlign="center">
          <div mat-dialog-content class="buffer-padding-x">
            We'll create a snippet of custom code to manually embed in your site to allow for our tracking.
          </div>
          <button mat-icon-button (click)="toggleCollapse($event)">
            <mat-icon>{{ collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
          </button>
        </div>
      </div>

      <div [fxShow]="!collapsed" class="">
        <div mat-dialog-content class="buffer-padding-y">
          <h4 mat-dialog-title>
            Installation Instructions
          </h4>
          <p>
            You'll need to add the Tracking Tag embed code to your website. The process is similar to a manual install of
            Google Analytics.
          </p>
          <mat-list>
            <mat-list-item>
              <mat-icon mat-list-icon>content_copy</mat-icon>
              <p matLine>Copy the entire embed code below.</p>
            </mat-list-item>
          </mat-list>
          <div mat-dialog-content class="traaqr-card embed-code-card">
            <mat-card-content>
              <code>{{ embedCode }}</code>
            </mat-card-content>

            <div fxLayout="row" fxLayoutAlign="center" class="int-add-container">
              <button mat-stroked-button color="primary" (click)="copyEmbedCode()">
                <mat-icon mat-list-icon>content_copy</mat-icon>
                <span class="center-text">COPY EMBED CODE</span>
              </button>
            </div>
          </div>
          <mat-list>
            <mat-list-item>
              <mat-icon mat-list-icon>content_paste</mat-icon>
              <p matLine>
                Paste the code into <b>every</b> page on your site, inside the <code>&lt;head&gt;</code> section - in a
                global header, if possible.
              </p>
              <p matLine>
                <a class="mat-text-primary" target="_new" href="https://codex.wordpress.org/Using_Javascript">Click here</a>
                for an example of how you can do this via the global <code>header.php</code> on a Wordpress site.
              </p>
              <p style="padding-top: 5px" matLine>
                If you are using Google Tag Manager, you can find installation instructions
                <a class="mat-text-primary" target="_new" href="https://www.myadvocado.com/help/getting-started/embed-code"
                >here</a
                >
              </p>
            </mat-list-item>
            <mat-list-item>
              <mat-icon mat-list-icon>web</mat-icon>
              <p matLine>You will have to visit at least one page on your site so that we can detect the embed code.</p>
              <p matLine>Visit your site, then come back to this page to refresh your status</p>
            </mat-list-item>
            <mat-list-item>
              <mat-icon mat-list-icon>refresh</mat-icon>
              <p matLine>
                After visiting your site, click the <b>Refresh Embed Status</b> button to check if your embed code is
                installed correctly.
              </p>
            </mat-list-item>
          </mat-list>

          <div fxLayout="row" fxLayoutAlign="center" class="int-add-container">
            <button mat-stroked-button color="primary" (click)="refreshData()">
              <mat-icon>autorenew</mat-icon>
              <span class="center-text">REFRESH EMBED STATUS</span>
            </button>
          </div>

          <p>Having trouble? Send an email to support@myadvocado.com</p>
        </div>
      </div>
    </div>

    <hr class="buffer-padding-y"/>

    <h4 mat-dialog-title>IP Address Exclusion</h4>

    <p>
      Input IP addresses that you want to exclude from appearing in your Advocado reports. For example, you may want to
      exclude known bots or IP Addresses that belong to your company.
    </p>

    <div *ngFor="let ip of traaqrTag.ips; index as i">
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="IP Address"
          [ngModel]="ip"
          disabled
          pattern="\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}"
          name="ipaddress"
        />
      </mat-form-field>
      <button mat-icon-button (click)="removeIp(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="IP Address"
          [(ngModel)]="newIp"
          pattern="\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}"
          name="ipaddress"
        />
      </mat-form-field>
    </div>

    <div>
      <button mat-stroked-button (click)="addIp($event)" [disabled]="addIpDisabled()" color="primary">
        <mat-icon>add</mat-icon>
        <span>ADD IP ADDRESS</span>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <div fxLayout="row">
    <button mat-button mat-dialog-close>CANCEL</button>
  </div>

  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-raised-button (click)="save($event)" [appShowSpinner]="saving" [buttonText]="'SAVE'" color="primary">
      SAVE
    </button>
  </div>
</div>
